import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';

/** Bottom-sheet. Управляется родителем через open/onClose. */
export function Sheet({ open, onClose, children }: { open: boolean; onClose: () => void; children: ReactNode }) {
  if (!open) return null;
  return createPortal(
    <div className="sheet-backdrop" onClick={onClose}>
      <div className="sheet" onClick={(e) => e.stopPropagation()} role="dialog">
        <div className="handle" />
        {children}
      </div>
    </div>,
    document.body,
  );
}
